import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.511 12.566 8 9.334l1.489 3.232c.431.938.647 1.407.418 1.745l-.019.027c-.244.33-.792.33-1.888.33s-1.644 0-1.888-.33l-.02-.027c-.228-.338-.012-.807.42-1.745"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7.999",
      cy: "8.001",
      r: "1.333",
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M2.666 12.001a6.667 6.667 0 1 1 10.667 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M5.019 10.667a4 4 0 1 1 5.963 0"
    }, null, -1)
  ]))]))
}
export default { render: render }